"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconAdFree = Experimental__IconAdFree;
exports.IconAdFree = IconAdFree;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconAdFree/index.tsx)
 */
function IconAdFree(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M12.25 1.5a.75.75 0 0 0-1.175-.618l-4.438 3.05a1.25 1.25 0 0 1-.708.22H1.25A1.248 1.248 0 0 0 0 5.401v5.353c.01.18.095.407.237.62l1.338 2.331c.742 1.293 1.592 1.989 2.558 2.146.928.152 1.749-.236 2.327-.572l.224-.13a.755.755 0 0 0 .275-1.028l-1.215-2.117h.248c.228 0 .452.062.647.18l4.473 2.707a.75.75 0 0 0 1.138-.642v-1.857a4.476 4.476 0 0 1-1.5-.346v.873l-3.334-2.018a2.75 2.75 0 0 0-1.424-.397H1.5V5.651h4.43c.555 0 1.098-.168 1.556-.483l3.264-2.243v.828c.465-.197.97-.317 1.5-.346V1.5ZM2.872 12.953l-.544-.948h1.7l.135.257a.827.827 0 0 0 .013.024l1.1 1.918c-.331.147-.625.209-.9.164-.35-.057-.882-.33-1.504-1.415Z\'/><path d=\'M13.97 5.37a.75.75 0 1 1 1.06 1.06L13.56 7.9l1.47 1.47a.75.75 0 0 1-1.06 1.06L12.5 8.96l-1.47 1.47a.75.75 0 0 1-1.06-1.06l1.47-1.47-1.47-1.47a.75.75 0 0 1 1.06-1.06l1.47 1.47 1.47-1.47Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M18 3a1 1 0 0 0-1.581-.814L9.94 6.814A1 1 0 0 1 9.36 7H3a2 2 0 0 0-2 2v5c0 .412.128.798.347 1.12l2.056 3.56c1.101 1.908 2.292 2.949 3.61 3.242 1.307.291 2.441-.223 3.237-.683l.303-.174a1 1 0 0 0 .366-1.366L8.783 16h.576a1 1 0 0 1 .581.186l6.479 4.628A1 1 0 0 0 18 20v-3.022a5.465 5.465 0 0 1-2-.578v1.657l-4.897-3.498A3 3 0 0 0 9.359 14H3.01L3 13.983V9h6.36a3 3 0 0 0 1.743-.559L16 4.943V6.6a5.465 5.465 0 0 1 2-.578V3ZM5.135 17.68 4.165 16h2.34l.406.755.015.028 1.743 3.019c-.441.186-.837.253-1.22.168-.533-.118-1.34-.603-2.314-2.29Z\'/><path d=\'M17.707 14.707a1 1 0 0 1-1.414-1.414l1.793-1.793-1.793-1.793a1 1 0 0 1 1.414-1.414l1.793 1.793 1.793-1.793a1 1 0 1 1 1.414 1.414L20.914 11.5l1.793 1.793a1 1 0 0 1-1.414 1.414L19.5 12.914l-1.793 1.793Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconAdFree is deprecated and will be archived soon. Use IconAdFree instead.
 */
function Experimental__IconAdFree(props) {
  return /*#__PURE__*/_react["default"].createElement(IconAdFree, props);
}